import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  const pillars = [{
    emoji: '🍀',
    text: 'Ingredientes suaves y efectivos'
  }, {
    emoji: '🫧',
    text: 'Rutina minimalista (menos es más)'
  }, {
    emoji: '🤍',
    text: 'Enfoque en piel real (sin filtros)'
  }, {
    emoji: '✨',
    text: 'Resultados progresivos y documentados'
  }];
  return <section className="py-24 bg-brand-cream relative overflow-hidden pt-[20px] pb-[20px]" data-id="element-204" data-mp="131h9ec76kiv">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-brand-beige/30 rounded-l-full blur-3xl -z-10 animate-pulse-glow" data-id="element-205" data-mp="3t6kff7kr4fvf" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-brand-gold/15 rounded-r-full blur-3xl -z-10 animate-pulse-glow" style={{
      animationDelay: '2s'
    }} data-id="element-206" data-mp="5usyuzddlfwv" />

      <div className="container mx-auto px-6 md:px-12 pt-[20px] pb-[20px] relative z-10" data-id="element-207" data-mp="fu0j86ij2ath">
        <div className="max-w-4xl mx-auto" data-id="element-208" data-mp="36b5jowij3aet">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-209" data-mp="36c6wb5f704yn">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-6" data-id="element-210" data-mp="3p8oua4kmx13c">
              La solución: Skincare Coreano,{' '}
              <span className="italic text-brand-sage-dark" data-id="element-211" data-mp="3u688x5l8vfvt">simple y real</span>{' '}
              🌿
            </h2>
            <p className="text-lg text-brand-charcoal/80 font-light" data-id="element-212" data-mp="6v8wwxpg1nzo">
              La filosofía K-Beauty no se trata de ocultar imperfecciones, sino
              de nutrir la piel desde la raíz para que brille con luz propia.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-213" data-mp="gty7e5f0g65w">
            {pillars.map((pillar, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-6 bg-white/80 backdrop-blur-sm rounded-2xl border border-brand-beige/50 soft-glow-hover transition-all" data-id="element-214" data-mp="2cuqg35ojg81t" data-mpi={index}>
                <span className="text-2xl mt-1 flex-shrink-0" data-id="element-215" data-mp="30m48tcqlq5nb">
                  {pillar.emoji}
                </span>
                <p className="text-lg text-brand-charcoal font-medium font-serif pt-1" data-id="element-216" data-mp="1b88uzp6tg6wc">
                  {pillar.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}